import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './CheckoutPage.module.css';
import Checkmark from '../../../Utils/Assets/SVGs/Checkmark';

const OrderSuccessPage: React.FC = () => {
  const navigate = useNavigate();

  const goHome = useCallback(() => {
    navigate('/', { replace: true });
  }, [navigate]);

  const goMyOrders = useCallback(() => {
    navigate('/my-orders', { replace: true });
  }, [navigate]);

  return (
    <main className={styles.successContainer} data-testid="order-success-page">
      <div className={styles.successIcon} data-testid="order-success-icon">
        <Checkmark data-testid="order-success-checkmark" />
      </div>

      <h2 className={styles.successTitle} data-testid="order-success-title">
        Order Placed Successfully
      </h2>

      <p className={styles.successText} data-testid="order-success-message">
        Your order has been successfully placed.
      </p>

      <div className={styles.successActions} data-testid="order-success-actions">
        <button
          type="button"
          className={styles.successBtnSecondary}
          onClick={goHome}
          data-testid="order-success-home-button"
        >
          Back to home page
        </button>

        <button
          type="button"
          className={styles.successBtnPrimary}
          onClick={goMyOrders}
          data-testid="order-success-my-orders-button"
        >
          My orders
        </button>
      </div>
    </main>
  );
};

export default OrderSuccessPage;
